export default "__VITE_ASSET__DrxGvqAu__"